import { LucideIcon } from 'lucide-react';

interface FeatureCardProps {
  icon: LucideIcon;
  title: string;
  description: string;
}

export function FeatureCard({ icon: Icon, title, description }: FeatureCardProps) {
  const IconComponent = Icon;

  return (
    <div className="bg-white p-8 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2">
      {/* Icône avec couleur et fond adapté */}
      <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-primary-main/10 mb-6">
        <IconComponent className="h-6 w-6 text-primary-main" />
      </div>

      {/* Titre et description */}
      <h3 className="text-xl font-semibold mb-3 text-primary-dark">{title}</h3>
      <p className="text-gray-600 leading-relaxed">{description}</p>
    </div>
  );
}
